/**
 * DevExtreme (ui/html_editor/formats/align.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _quill_importer = require("../quill_importer");
var quill = (0, _quill_importer.getQuill)();
var AlignStyle = quill.import("attributors/style/align");
AlignStyle.whitelist.push("left");
exports.default = AlignStyle;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/html_editor/formats/align.js
// module id = 1154
// module chunks = 0